import React, { useEffect, useState } from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import Input from "sushiweb/InputTypes/Input";
import Permission from "../../Common/Permission";
import MenuActionMappings from "../../../constants/Menu/MenuActionsMappings.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import * as AttributeMapping from "../../../store/actions/AttributeMapping";
import { isValNull } from "../../../utils";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";

export const AttributeMappingModal = (props) => {
  const {
    modalState,
    handleClose,
    actionListData,
    createAttributeMapping,
    updateAttributeMapping,
    userId,
    actionAttributeMappingData,
    initialState,
    editState,
    newState,
    setNewState,
    setEditState,
    formatTime,
    initialActionType,
  } = props;

  const allActions = MenuActionMappings[MenuNames.ATTRIBUTE_MAPPING];
  const getRequiredButtonPerms = () => {
    switch (modalState) {
      case "Add":
        return [allActions.CREATE];
      case "Edit":
        return [allActions.UPDATE];
      default:
        return [];
    }
  };

  const timeOptions = [];
  const periods = ["AM", "PM"];

  for (let j = 0; j < 24; j++) {
    const hour = j === 0 ? 12 : j > 12 ? j - 12 : j;
    const period = j < 12 ? periods[0] : periods[1];

    timeOptions.push(`${hour}:00 ${period}`);

    timeOptions.push(`${hour}:30 ${period}`);
  }

  const handleChange = (key, value) => {
    let values = { ...newState };
    values[key] = value;
    switch (key) {
      case "action":
        values["attribute_type"] = "";
        values["attribute_value"] = "";
        break;
      case "attribute_type":
        values["attribute_value"] = "";
        break;
      default:
        break;
    }
    setNewState(values);
  };

  const handleStartTimeChange = (key, value) => {
    let values = { ...newState };
    let restricted_period = values.restricted_period;
    restricted_period[key].start_time = value;
    setNewState(values);
  };

  const handleEndTimeChange = (key, value) => {
    let values = { ...newState };
    let restricted_period = values.restricted_period;
    restricted_period[key].end_time = value;
    setNewState(values);
  };

  const handleEditStartTimeChange = (key, value) => {
    let values = { ...editState };
    let restricted_period = values.restricted_period;
    restricted_period[key].start_time = value;
    setEditState(values);
  };

  const handleEditEndTimeChange = (key, value) => {
    let values = { ...editState };
    let restricted_period = values.restricted_period;
    restricted_period[key].end_time = value;
    setEditState(values);
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const handleClick = (type) => {
    switch (type) {
      case "Submit":
        const { emailId, ...filters } = newState;
        filters.user_id = userId;
        filters.restricted_period = formatTime(filters.restricted_period);
        createAttributeMapping(filters, initialActionType);
        setNewState({ ...initialState });
        handleClose();
        break;
      case "Update":
        const data = { ...editState };
        data.user_id = userId;
        data.restricted_period = formatTime(data.restricted_period);
        updateAttributeMapping(data, initialActionType);
        handleClose();
        break;
      default:
        break;
    }
  };

  const getAttributeListData = (action) => {
    const attributeList = actionAttributeMappingData[action] || [];
    return attributeList;
  };

  return (
    <NoFooterModal
      header={true}
      heading={`${
        modalState === "Add" ? "Create" : modalState
      } Attribute Mapping`}
      handleClose={handleClose}
      id="AttributeMappingModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="cancelButton"
            onClick={() => handleClose()}
            className="sushi-btn"
          >
            Cancel
          </Button>
          <Permission requiredPerms={getRequiredButtonPerms()}>
            <Button
              data-testid="submitButton"
              className="sushi-btn"
              onClick={() =>
                handleClick(modalState === "Add" ? "Submit" : "Update")
              }
            >
              {modalState === "Add" ? "Create" : "Update"}
            </Button>
          </Permission>
        </BottomSectionModal>
      }
    >
      <Input
        value={initialState.emailId}
        data-testid="eamilId"
        id="sushi-input"
        disabled
        label="Email Id"
      />

      <PaginatedReactDropdown
        options={actionListData}
        data-testid="action"
        labelKey="label"
        valueKey="value"
        labelWidth="16%"
        disabled={modalState === "Edit"}
        value={
          modalState === "Edit"
            ? editState.action
            : getInputLabel(newState.action, actionListData, "key", "label")
        }
        handleChange={handleChange}
        keyToChange="action"
        placeholder="Action"
        showCross={false}
        id="actionDropdown"
      />
      <PaginatedReactDropdown
        options={getAttributeListData(newState.action)}
        data-testid="attribute"
        labelKey="label"
        disabled={modalState === "Edit"}
        valueKey="value"
        labelWidth="16%"
        value={
          modalState === "Edit"
            ? editState.attribute_type
            : getInputLabel(
                newState.attribute_type,
                getAttributeListData(newState.action),
                "key",
                "label"
              )
        }
        handleChange={handleChange}
        keyToChange="attribute_type"
        placeholder="Attribute Type"
        showCross={false}
        id="attributeDropdown"
      />
      <Input
        value={
          modalState === "Edit"
            ? editState.attribute_value
            : newState.attribute_value
        }
        disabled={modalState === "Edit"}
        data-testid="attributeValue"
        id="sushi-input"
        onChange={(e) => handleChange("attribute_value", e)}
        label="Attribute Value"
      />
      <div className="restrictedHoursContainer">
        <div
          className="startTimes "
          style={{ display: "flex", flexDirection: "row" }}
        >
          <PaginatedReactDropdown
            options={timeOptions}
            data-testid="startTime1"
            labelKey="label"
            valueKey="value"
            labelWidth="16%"
            value={
              modalState === "Edit"
                ? editState.restricted_period[0].start_time
                : getInputLabel("", timeOptions, "key", "label")
            }
            placeholder="Start Time 1"
            showCross={false}
            keyToChange={0}
            id="startTime1Dropdown"
            handleChange={
              modalState === "Edit"
                ? handleEditStartTimeChange
                : handleStartTimeChange
            }
          />
          <PaginatedReactDropdown
            options={timeOptions}
            data-testid="startTime2"
            labelKey="label"
            valueKey="value"
            labelWidth="16%"
            value={
              modalState === "Edit"
                ? editState.restricted_period[1].start_time
                : getInputLabel("", timeOptions, "key", "label")
            }
            placeholder="Start Time 2"
            showCross={false}
            keyToChange={1}
            id="startTime2Dropdown"
            handleChange={
              modalState === "Edit"
                ? handleEditStartTimeChange
                : handleStartTimeChange
            }
          />
          <PaginatedReactDropdown
            options={timeOptions}
            data-testid="startTime3"
            labelKey="label"
            valueKey="value"
            labelWidth="16%"
            value={
              modalState === "Edit"
                ? editState.restricted_period[2].start_time
                : getInputLabel("", timeOptions, "key", "label")
            }
            placeholder="Start Time 3"
            showCross={false}
            keyToChange={2}
            id="startTime3Dropdown"
            handleChange={
              modalState === "Edit"
                ? handleEditStartTimeChange
                : handleStartTimeChange
            }
          />
        </div>
        <div
          className="endTimes"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <PaginatedReactDropdown
            options={timeOptions}
            data-testid="endTime1"
            labelKey="label"
            valueKey="value"
            labelWidth="16%"
            value={
              modalState === "Edit"
                ? editState.restricted_period[0].end_time
                : getInputLabel("", timeOptions, "key", "label")
            }
            placeholder="End Time 1"
            showCross={false}
            keyToChange={0}
            id="endTime1Dropdown"
            handleChange={
              modalState === "Edit"
                ? handleEditEndTimeChange
                : handleEndTimeChange
            }
          />
          <PaginatedReactDropdown
            options={timeOptions}
            data-testid="endTime2"
            labelKey="label"
            valueKey="value"
            labelWidth="16%"
            value={
              modalState === "Edit"
                ? editState.restricted_period[1].end_time
                : getInputLabel("", timeOptions, "key", "label")
            }
            placeholder="End Time 2"
            showCross={false}
            keyToChange={1}
            id="endTime2Dropdown"
            handleChange={
              modalState === "Edit"
                ? handleEditEndTimeChange
                : handleEndTimeChange
            }
          />
          <PaginatedReactDropdown
            options={timeOptions}
            data-testid="endTime3"
            labelKey="label"
            valueKey="value"
            labelWidth="16%"
            value={
              modalState === "Edit"
                ? editState.restricted_period[2].end_time
                : getInputLabel("", timeOptions, "key", "label")
            }
            placeholder="End Time 3"
            showCross={false}
            keyToChange={2}
            id="endTime3Dropdown"
            handleChange={
              modalState === "Edit"
                ? handleEditEndTimeChange
                : handleEndTimeChange
            }
          />
        </div>
      </div>
    </NoFooterModal>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    createAttributeMapping: bindActionCreators(
      AttributeMapping.createAttributeMapping,
      dispatch
    ),
    updateAttributeMapping: bindActionCreators(
      AttributeMapping.updateAttributeMapping,
      dispatch
    ),
  };
};

const mapStateToProps = (state) => {
  const { AttributeMapping = {} } = state;
  return {
    currentState: AttributeMapping,
    actionListData: AttributeMapping.actionList || [],
    attributeListData: AttributeMapping.attributeList || [],
    attributeValueListData: AttributeMapping.attributeValueList || [],
    userId: AttributeMapping.userId || 0,
    actionAttributeMappingData: AttributeMapping.actionAttributeMapping || {},
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AttributeMappingModal);
